import httpService from "./httpService";

export const validateOrCreateUser = async () => {
  const token = sessionStorage.getItem("access_token");
  if (!token) throw new Error("No access token available");

  try {
    console.log(
      "[UserService validateOrCreateUser] Calling /User/ValidateOrCreateUser"
    );
    const response = await httpService.post("/User/ValidateOrCreateUser", {});
    console.log(
      "[UserService validateOrCreateUser] Success",
      response.data
    );
    return response.data;
  } catch (error) {
    console.error(
      "[UserService validateOrCreateUser] Failed",
      error
    );
    throw error;
  }
};
